export default {
  meta: {
    title: '代理商管理'
  }
};
